<template>
  <!-- 抬头管理 -->
  <div>
    <el-card shadow="never" class="real_card">
      <div slot="header" class="clearfix header">
        <div class="desciconLarge"></div>
        <span class="font18">抬头管理</span>
        <el-button class="add_line" size="mini" type="success" @click="addInvoice" plain>新增抬头</el-button>
      </div>
      <div style="margin-bottom: 10px">
        <el-card class="box-card" style="margin-bottom: 20px" v-for="(item , index) in invoiceHeadList" :key="item.headId">
            <div slot="header" class="clearfix inner">
                <div class="left">
                    <span>发票抬头{{index+1}}</span>
                </div>
                <div class="right">
                    <el-tag  style="margin-right: 10px" size="mini" v-if="item.isDefault === 1">默认抬头</el-tag>
                    <!-- <el-button style="margin-right: 10px" :disabled="true" type="text" v-if="item.isDefault === 1">默认抬头</el-button> -->
                    <el-button style="margin-right: 10px" type="text" @click="setDefaultHead(item)" v-if="item.isDefault === 0 || item.isDefault == null">设为默认抬头</el-button>
                    <el-button style="margin-right: 10px" type="text" @click="editHead(item)">修改抬头</el-button>
                    <el-button style="margin-right: 10px;color: #FF0000" @click="delHandle(item.headId)" v-if="item.isDefault !== 1" type="text">删除抬头</el-button>
                </div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">发票抬头:</div>
                    <div class="invoice_head_item__content">{{item.invoiceTitle || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">企业税号:</div>
                    <div class="invoice_head_item__content">{{item.enterpriseTaxNumber || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">开户行名称:</div>
                    <div class="invoice_head_item__content">{{item.openBankName || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">开户行账户:</div>
                    <div class="invoice_head_item__content">{{item.openBankAccount || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">注册地址:</div>
                    <div class="invoice_head_item__content">{{item.registeredAddress || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">注册电话:</div>
                    <div class="invoice_head_item__content">{{item.registeredTelephone || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">收件人姓名:</div>
                    <div class="invoice_head_item__content">{{item.addressee || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">收件地址:</div>
                    <div class="invoice_head_item__content">{{item.deliveryAddress || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">收件邮箱:</div>
                    <div class="invoice_head_item__content">{{item.receivingContact || '-'}}</div>
            </div>
            <div class="invoice_head_item">
                <!-- 列表内容 -->
                    <div class="invoice_head_item__title">联系方式:</div>
                    <div class="invoice_head_item__content">{{item.receivingContactInformation || '-'}}</div>
            </div>
        </el-card>
      </div>
    </el-card>
    <addInvoicePop ref="addInvoicePop" @close="close" v-if="addInvoicePopVisible"></addInvoicePop>
  </div>
</template>
<script>
import { setDefault, deleteInvoiceHead, listInvoiceHead } from "@/api/request";
import { getClient } from "@/plugins/auth";
import addInvoicePop from "./formPop/addInvoicePop.vue"
export default {
  components: {
    addInvoicePop
  },
  data() {
    return {
      addInvoicePopVisible: false,
      invoiceHeadList:[],
      userInfo: JSON.parse(getClient()),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    addInvoice(){
        this.addInvoicePopVisible = true
        this.$nextTick(() => {
            this.$refs.addInvoicePop.init()
        })
    },
    editHead(item){
      this.addInvoicePopVisible = true
        this.$nextTick(() => {
            this.$refs.addInvoicePop.init(item)
        })
    },
    close(flag){
        this.addInvoicePopVisible = false
        this.getList(flag)
    },
    getList(flag) {
       listInvoiceHead({clientId: this.userInfo.clientId}).then(res => {
        if(flag){
          let obj = {
						headId: res.rows[0].headId,
						clientId: res.rows[0].clientId
					}
          if(res.rows.length === 1){
            setDefault({headId: obj.headId,clientId: this.userInfo.clientId}).then(res => {
              this.getList(false)
            })
          }
        }
        this.invoiceHeadList = res.rows
       })
    },
    setDefaultHead(data){
        setDefault({headId: data.headId,clientId: this.userInfo.clientId}).then(res => {
            this.getList()
            this.$message.success("操作成功");
        })
    },

    //删除
    delHandle(id) {
      this.$confirm("确认删除该发票抬头吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      })
        .then(function () {
          return deleteInvoiceHead(id);
        })
        .then(() => {
          this.getList();
          this.$message.success("操作成功");
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.add_line{
    position: absolute;
    right: 20px;
}
.header{
    position: relative;
}
.inner{
    display: flex;
    align-items: center;
    padding: 0 20px;
    .left {
        width: 200px;
    }
    .right{
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
.invoice_head_item{
    display: flex;
    padding-left: 20px;
    height: 40px;
    align-items: center;
    cursor: pointer;
    .invoice_head_item__title{
        color: #444444;
        font-size: 14px;
        width: 90px;
        font-weight: bold;

    }
    .invoice_head_item__content{
        color: #444444;
        font-size: 14px;
        padding-left: 10px;
    }
}
.invoice_head_item:hover{
    box-shadow: 0px 0px 19px #ebebeb;
    border-radius: 5px;
    // .invoice_head_item__title{
    //     font-size: 15px;
    // }
    // .invoice_head_item__content{
    //     font-size: 15px;
    // }
}
</style>